module.exports = __webpack_public_path__ + "static/media/funny_dots.a35c3827.svg";